<template>
  <div class="cartnav container-fluid p-0 sticky-top">
    <div class="row w-100">
      <div class="col-4 d-flex align-items-center"></div>
      <div class="col-4 text-center"></div>
      <div class="col-4 d-flex justify-content-end">
        <router-link to="/cart" :class="{ squiggle: cartStore.addedToCart }">
          <div class="btn cartbutton position-relative">
            <i
              class="bi bi-cart fs-3"
              :class="{ squiggle: cartStore.addedToCart }"
            ></i>
            <span
              class="cartpill position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
            >
              {{ cartStore.cart.length }}
              <span class="visually-hidden">items in cart</span>
            </span>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-facing-decorator";
import { useCartStore } from "../../store/cartStore";

@Component
class CartNav extends Vue {
  cartStore = useCartStore();
}
export default CartNav;
</script>
